import {
  setCollectionModal,
  showBankingCommentsModal,
  showSiteVarianceHistoryModal,
} from "@actions/modals";
import collections from "@api/collections";
import { connect } from "react-redux";
import BaseCollection from "./BaseCollection";

class CollectionBanking extends BaseCollection {
  fnRowClick = collections.getBankingWeekDetail;
  fnRefresh = collections.getBankingWeek;
  fnGetSummaryPdf = collections.getBankingSummaryPdf;
  fnGetVariancePdf = collections.getBankingVariancePdf;
  fnGetExport = collections.getBankingWeekExport;
  fnGetSummaryReportPdf = collections.getSummaryReportPdf;
  isPerformance = false;

  reportName = "Banking Report PDF";
  modalTitle = "Collection Week Banking";
  summaryReportFileName = "Summary Report";
  reportFileName = "Collection Week Banking";
  exportFileName = "Collection Week Banking Export CSV";
  handleVarianceHistory = () => this.props.showSiteVarianceHistoryModal(true);
}

const mapStateToProps = (state) => {
  return {
    installationsFilters: state.installationsFilters,
    collectionsFilters: state.collectionsFilters,
    collectionModal: state.collectionModal,
  };
};

export default connect(mapStateToProps, {
  showSiteVarianceHistoryModal,
  setCollectionModal,
  showBankingCommentsModal,
})(CollectionBanking);
